const EnumAgendaUtilizadaEmpresa = {
    SOC: 'SOC',
    INTERNA: 'Interna'
};

export default EnumAgendaUtilizadaEmpresa;
